export default __webpack_public_path__ + "static/constat_de-cd5a803d6603b5b1ddd0d37ce29b8572.mp4";